module.exports = __webpack_public_path__ + "img/question-mark.ab5d8995.svg";